import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../auth/auth';

/**
 * `/menus` (Menu Configuration) and `/client` (Client Configuration) are
 * Super-Admin-only screens - letting an Admin role reach them would expose
 * platform-wide configuration (which routes every tenant's Admin menu can
 * see, and the tenant/client list itself). Backend already refuses to
 * assign either route's menu to the Admin audience or allocate it to a
 * client (menuRepository.assignAudience / clientMenuAllocationRepository.
 * scopeToAdminCatalogue), so an Admin's own menuList/permission-guard check
 * would already exclude these routes in practice - this guard is a direct,
 * explicit second line of defense at the route level itself, not dependent
 * on that indirect chain (a stale cached menu list, a future change to how
 * menuList is built, etc.).
 *
 * "Super Admin" mirrors the same check menu-list.ts's own in-page actions
 * already gate on (isSuperAdmin = !currentUser()?.client) - the platform
 * super admin has no `client` on their JWT/currentUser, every Client Admin
 * does.
 */
// Usable as both canActivate and canActivateChild - the two guard fn types
// share the same (route, state) signature.
export const superAdminGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);
  const isSuperAdmin = !auth.currentUser()?.client;
  return isSuperAdmin ? true : router.createUrlTree(['/access-denied']);
};
